import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

type UseGameplayLearnHowProxyProps = {
  url: string;
  isOpen: boolean;
};

export const useGameplayLearnHowProxy = ({ url, isOpen }: UseGameplayLearnHowProxyProps) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const proxyUrl = `/api/create/gameplay-learn-how-proxy?url=${encodeURIComponent(url)}`;

  const {
    isLoading: isLoadingQuery,
    error: proxyError,
    isSuccess,
    data: validatedResponse,
  // eslint-disable-next-line local-rules/require-query-stale-time
  } = useQuery({
    queryKey: ['gameplay-learn-how-proxy', url],
    queryFn: async () => {
      setIframeLoaded(false);
      const response = await fetch(proxyUrl);
      if (!response.ok) {
        throw new Error(`Proxy failed with status: ${response.status}`);
      }
      const contentType = response.headers.get('content-type');
      if (!contentType?.includes('text/html')) {
        throw new Error('Proxy returned non-HTML content');
      }
      return response.text();
    },
    enabled: isOpen && !!url,
  });

  return {
    isLoading: isLoadingQuery,
    error: proxyError,
    isSuccess,
    data: validatedResponse,
    iframeLoaded,
    proxyUrl,
    setIframeLoaded,
  };
};
